// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDTypography from "../../components/MDTypography";
import ProjectOverview from "./components/ProjectOverview";
import ProjectCard from "./components/ProjectCard"

import { useState, useEffect } from "react";
import { useCimbeo } from "../../context";
import TopNavBar from "../../components/TopNavBar/DefaultNavBar";

function Projects() {
    const { setProjectName, setProjectId } = useCimbeo();
    
    useEffect(() => {
        setProjectName("");
        setProjectId("");
    }, [setProjectName, setProjectId]);

    const {projects} = useCimbeo();

    // Create state on index to track which index in the array is selected to display
    // on the right side of the page
    const [selectedProjectIndex, updateIndex] = useState(0);

    return (
        <DashboardLayout>
            <TopNavBar />
            <MDBox style={{height: "calc(100vh - 100px)", display: "flex", overflow: "hidden"}}>
                <Grid container spacing={2} style={{alignItems: "stretch", height: "100%", display: "flex"}}>
                    <Grid item xs={12} md={5} style={{flex: 1, height: "100%", overflow: "auto"}}>
                        <Card sx={{height: "100%",  overflow: "auto"}}>
                            <MDBox pt={3} pb={1} px={2}>
                                <MDTypography variant="h4" fontWeight="medium">
                                Current Projects
                                </MDTypography>
                            </MDBox>
                            <MDBox pb={2} px={2}>
                                <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                                <Grid  display="flex" flexDirection="column"> 
                                    {
                                        projects.map((item, index) => (
                                            <ProjectCard 
                                                name={item.title} 
                                                description={item.description} 
                                                index={index} 
                                                updateIndex={updateIndex}
                                            />
                                        ))
                                    }
                                </Grid>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={7} style={{flex: 1, height: "100%", overflow: "auto"}}>
                        <ProjectOverview data={projects[selectedProjectIndex]}/>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Projects;